import { useNavigate } from "react-router-dom";
import useAuth from "../../../components/hooks/useAuth";
import { useTheme } from "../../../components/hooks/useTheme";
import CustomerSelectWrapper from "./CustomerSelectWrapper";
import useConfirm from "../../../components/hooks/useConfirm";
import { useEffect, useState } from "react";
import { branchTimezone } from "../../../utils/summaryCalculation";
import { getReservationHistoryByCustomer } from "../../../services/reservationHistory";
import axios from "axios";
import baseURL from "../../../configs/api";
import { getCustomer, put_Customer } from "../../../services/customer";
import { getCustomersExtraInformationsByCustomerId } from "../../../services/customerExtraInformation";
import { format } from "date-fns";
import { Button, CircularProgress, Divider } from "@mui/material";
import Select from "react-select";
import AddIdentification from "../../contacts/customers/AddIdentification";
import { AddOutlined } from "@mui/icons-material";
import { AddNewCustomer } from "./AddNewCustomer2";
import PhoneNumberInput from "../../../components/common/PhoneNumberInput";
import colorConfigs from "../../../configs/colorConfigs";
import EmailValidatedComponent from "../../../components/EmailValidatedComponent";
import moment from "moment";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import useGeneral from "../../../components/hooks/useGeneral";

type ExtraInformation = {
  id: number;
  idNumber: string;
  issueDate: string;
  exprationDate: string;
  filePath: string;
  idTypeId: string;
  customerId: number;
  type: string;
  imageSize: number,
  uploadedAt: string,
  uploadedBy: string,
};

type CustomerProps = {
  goToNextPage: (page: number) => void;
  getDataFromCustomer: (customerId: number, localAddress: string) => void;
  selectedVehicleClass: any;
  formattedCreatedAt: string;
  preferredDateFormat: string;
  pickupDate: string;
  returnDate: string;
  returnTime: string;
  hideToolbar: boolean;
  setHideToolbar: (hideToolbar: boolean) => void;
  customerPrimaryKey: number;
  isFirstTime: boolean;
  setIsFirstTime: (value: boolean) => void;
  currentPage: string;
  isCompletedOrCancelled: boolean;
  reservationId: number;
  summaryData: any;
  setPleaseWaitPopup: (value: boolean) => void;
}

const monthNameOptions = [
  { value: "1", label: "1. January" },
  { value: "2", label: "2. February" },
  { value: "3", label: "3. March" },
  { value: "4", label: "4. April" },
  { value: "5", label: "5. May" },
  { value: "6", label: "6. June" },
  { value: "7", label: "7. July" },
  { value: "8", label: "8. August" },
  { value: "9", label: "9. September" },
  { value: "10", label: "10. October" },
  { value: "11", label: "11. November" },
  { value: "12", label: "12. December" },
];

const daysOptions: any = [];
for (let i = 1; i <= 31; i++) {
  daysOptions.push({ value: i, label: i });
}

const yearOptions: any = [];
for (let i = 1940; i <= new Date().getFullYear(); i++) {
  yearOptions.push({ value: i, label: i });
}

yearOptions.reverse();

export const Customer = ({
  goToNextPage,
  getDataFromCustomer,
  selectedVehicleClass,
  formattedCreatedAt,
  preferredDateFormat,
  pickupDate,
  returnDate,
  returnTime,
  hideToolbar,
  setHideToolbar,
  customerPrimaryKey,
  isFirstTime,
  setIsFirstTime,
  currentPage,
  isCompletedOrCancelled,
  reservationId,
  summaryData,
  setPleaseWaitPopup
}: CustomerProps) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { dateFormat }: any = useGeneral();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const navigate = useNavigate();

  const [customerId, setCustomerId] = useState<number>(0);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [Street, setStreet] = useState<string>("");
  const [street2, setStreet2] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [isRedFlag, setIsRedFlag] = useState<boolean>(false);
  const [redFlagReason, setRedFlagReason] = useState<string>("");
  const [localAddress, setLocalAddress] = useState<string>("");
  const [reservationHistoryLoaded, setReservationHistoryLoaded] = useState<boolean>(false);
  const [extraRow, setExtraRow] = useState<ExtraInformation[]>([]);
  const [allExtraValue, setAllExtraValue] = useState<boolean>(false);
  const [indexNumber, setIndexNumber] = useState<number>(0);
  const [addNewCustomer, setAddNewCustomer] = useState<boolean>(hideToolbar);
  const [historyValue, setHistoryValue] = useState<any[]>([]);
  const [pageNo, setPage] = useState<number>(-1);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [isNextPageLoading, setNextPageLoading] = useState<boolean>(false);
  const [options, setOptions] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const UpdateTimezone = branchTimezone(formattedCreatedAt);
  const [isHistory, setIsHistory] = useState<boolean>(false);

  useEffect(() => {
    if (customerPrimaryKey) {
      setCustomerId(customerPrimaryKey);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPrimaryKey]);

  useEffect(() => {
    if (summaryData) {
      setLocalAddress(summaryData?.localAddress || "");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summaryData]);

  useEffect(() => {
    if (customerId && isFirstTime && isHistory) {
      setReservationHistoryLoaded(false);
      getReservationHistoryByCustomer(customerId, tenantId)
        .then(data => {
          setHistoryValue(data);
          setReservationHistoryLoaded(true);
          handleTenantError(null);
        })
        .catch(error => {
          setHistoryValue([]);
          setReservationHistoryLoaded(true);
          handleTenantError(error);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, isHistory]);

  useEffect(() => {
    if (isHistory && isFirstTime) {
      setIsFirstTime(false);
    } else if (!isHistory && !isFirstTime) {
      setIsFirstTime(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHistory, isFirstTime])

  const handleAddExtraRow = () => {
    if (!isCompletedOrCancelled) {
      const data: ExtraInformation = {
        id: indexNumber + 1,
        idNumber: "",
        issueDate: "",
        exprationDate: "",
        filePath: "",
        idTypeId: "",
        customerId: customerId,
        type: "POST",
        imageSize: 0,
        uploadedAt: new Date(UpdateTimezone).toLocaleString(),
        uploadedBy: auth.givenname,
      };
      setIndexNumber(indexNumber + 1);
      setExtraRow((extraRow: ExtraInformation[]) => [...extraRow, data]);
    }
  };

  const handleDeleteExtraRow = async (index: number) => {
    if (!isCompletedOrCancelled) {
      if (extraRow.find((row: ExtraInformation) => row.id === index)?.type.split(" ")[0] === "PUT") {
        await axios
          .delete(`${baseURL}customerExtraInformation?id=${extraRow.find((row: ExtraInformation) => row.id === index)?.type.split(" ")[1]}&userId=${auth?.id}`, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            }
          })
          .then(() => {
            const newRow: ExtraInformation[] = extraRow.filter(
              (row: ExtraInformation) => row.id !== index
            );
            setExtraRow(newRow);
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      } else {
        const newRow: ExtraInformation[] = extraRow.filter(
          (row: ExtraInformation) => row.id !== index
        );
        setExtraRow(newRow);
      }
    }
  };

  const changeOnExtraValue = (row: ExtraInformation) => {
    const updatedExtraRow = extraRow.map((rowValue: ExtraInformation) => {
      return rowValue.id === row.id ? row : rowValue;
    })
    setExtraRow(updatedExtraRow);
  };

  useEffect(() => {
    if (customerId) {
      getCustomer(customerId, tenantId)
        .then(data => {
          setFirstName(data.firstName || "");
          setLastName(data.lastName || "");
          setEmailAddress(data.emailAddress || "");
          setPhoneNumber(data.phoneNumber || "");
          setStreet(data.street || "");
          setStreet2(data.street2 || "");
          setCity(data.city || "");
          setState(data.state || "");
          setCountry(data.country || "");
          setZip(data.zip || "");
          setIsRedFlag(data?.isRedFlag || false);
          setRedFlagReason(data?.redFlagReason || "");
          if (data.birthday) {
            setYear(new Date(data.birthday).getFullYear().toString());
            setDay(new Date(data.birthday).getDate().toString());
            setMonth((new Date(data.birthday).getMonth() + 1).toString());
          } else {
            setYear("");
            setDay("");
            setMonth("");
          }

          setSelectedOption({
            value: data.id,
            label: data.firstName + " " + data.lastName,
          });
          setNextPageLoading(false);
          handleTenantError(null);
        })
        .catch(error => handleTenantError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId, currentPage]);

  useEffect(() => {
    if (allExtraValue && extraRow?.length > 0) {
      const lastIndexValue: any = extraRow?.find((item: ExtraInformation) => extraRow[extraRow?.length - 1] === item);

      const lastIndexId = lastIndexValue?.id || 0;
      setIndexNumber(lastIndexId + 1);
    } else {
      setIndexNumber(0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allExtraValue, currentPage]);

  useEffect(() => {
    if (customerId > 0) {
      getCustomersExtraInformationsByCustomerId(customerId, tenantId)
        .then(data => {
          setExtraRow(
            data?.filter((value: any) => value.idTypeId !== 0)
              ?.map((item: ExtraInformation, index: number) => {
                return {
                  id: index + 1,
                  idNumber: item.idNumber,
                  issueDate: format(new Date(item.issueDate), "yyyy-MM-dd"),
                  exprationDate: format(new Date(item.exprationDate), "yyyy-MM-dd"),
                  filePath: item.filePath,
                  idTypeId: item.idTypeId,
                  customerId: item.customerId,
                  type: `PUT ${item?.id}`,
                  imageSize: item.imageSize,
                  uploadedAt: item.uploadedAt,
                  uploadedBy: item.uploadedBy
                };
              })
          );

          if (data?.filter((item: ExtraInformation) => parseInt(item.idTypeId) !== 0)?.length > 0) {
            setAllExtraValue(true);
          }
          handleTenantError(null);
        })
        .catch(error => {
          setExtraRow([]);
          setAllExtraValue(false)
          handleTenantError(error);
        });
    } else {
      setExtraRow([]);
      setAllExtraValue(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId]);

  const calculateAge = (date: string) => {
    var today = new Date();
    var birthDate = new Date(date);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isCompletedOrCancelled) {
      if (addNewCustomer) return;

      if (!customerId) {
        setConfirmData({
          title: 'Warning',
          summary: 'Please select a customer or create a new one',
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
        return;
      }

      if (extraRow?.length === 0) {
        setConfirmData({
          title: 'Warning',
          summary: 'Please add customer extra info',
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
        return;
      }

      const updateBirthday = `${year}-${month}-${day}`;

      if (
        calculateAge(updateBirthday) <
        selectedVehicleClass?.minimumRentalAllowedAge ||
        calculateAge(updateBirthday) > selectedVehicleClass?.maxRentalAllowedAge
      ) {
        setConfirmData({
          title: 'Warning',
          summary: 'You are not old enough to operate this vehicle.',
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
        return;
      }

      setPleaseWaitPopup(true);

      let hasInvalidDate = false;

      if (extraRow?.length > 0) {
        extraRow?.forEach((item: any) => {
          if (item?.issueDate && moment(item?.issueDate, "YYYY-MM-DD", true)?.isValid() && item?.exprationDate && moment(item?.exprationDate, "YYYY-MM-DD", true)?.isValid()) {
            const returnDateTime = new Date(returnDate);
            const exprationDate = new Date(item?.exprationDate);

            const pickupDateTime = new Date(pickupDate);
            const issuedDate = new Date(item?.issueDate);

            if (exprationDate < issuedDate) {
              setConfirmData({
                title: 'Warning',
                summary: `The expiration date for ID (${item?.idNumber}) cannot be earlier than the issued date.`,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                },
              });

              setConfirmPopup(true);
              setPleaseWaitPopup(false);
              hasInvalidDate = true;
              return;
            }

            if (exprationDate < returnDateTime) {
              setConfirmData({
                title: 'Warning',
                summary: `The expiration date for ID (${item?.idNumber}) cannot be earlier than the return date and time.`,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                },
              });

              setConfirmPopup(true);
              setPleaseWaitPopup(false);
              hasInvalidDate = true;
              return;
            }

            if (issuedDate > pickupDateTime) {
              setConfirmData({
                title: 'Warning',
                summary: `The issued date for ID (${item?.idNumber}) cannot be later than the pickup date and time.`,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                },
              });

              setConfirmPopup(true);
              setPleaseWaitPopup(false);
              hasInvalidDate = true;
              return;
            }
          } else {
            setConfirmData({
              title: 'Warning',
              summary: `Issued date and Expiration date format must be - ${preferredDateFormat?.replace(/yyyy/g, 'YYYY')}`,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              },
            });

            setConfirmPopup(true);
            setPleaseWaitPopup(false);
            hasInvalidDate = true;
            return;
          }

        });
      }

      if (hasInvalidDate) return;

      const paddedMonth = month.toString().padStart(2, "0");
      const paddedDay = day.toString().padStart(2, "0");
      const birthday = new Date(`${year}-${paddedMonth}-${paddedDay}`);

      put_Customer({
        id: customerId,
        firstName,
        lastName,
        emailAddress,
        phoneNumber,
        Street,
        street2,
        city,
        state,
        country,
        zip,
        birthday,
        isRedFlag,
        redFlagReason
      }, auth?.id, tenantId)
        .then(() => {
          savedExtraInfo();
          handleTenantError(null);
        })
        .catch(error => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    }
  };

  const savedExtraInfo = () => {
    if (!isCompletedOrCancelled) {
      if (extraRow?.length !== 0) {
        let shouldBlockNextPage = false;

        extraRow?.forEach(async (item: ExtraInformation, index: number) => {
          if (item.type.split(" ")[0] === "POST") {
            await axios
              .post(
                `${baseURL}customerExtraInformation?userId=${auth?.id}`,
                JSON.stringify({
                  idNumber: item?.idNumber,
                  issueDate: new Date(item?.issueDate),
                  exprationDate: new Date(item?.exprationDate),
                  filePath: item?.filePath,
                  idTypeId: item?.idTypeId,
                  customerId: item?.customerId,
                  imageSize: item?.imageSize,
                  uploadedAt: new Date(item?.uploadedAt),
                  uploadedBy: item?.uploadedBy
                }),
                {
                  headers: {
                    'X-Tenant-ID': tenantId,
                    "Content-Type": "application/json"
                  },
                  withCredentials: true,
                }
              )
              .then(() => {
                if (extraRow?.length === (index + 1) && !shouldBlockNextPage) {
                  getDataFromCustomer(customerId, localAddress);
                  goToNextPage(4);
                }
                handleTenantError(null);
              })
              .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
              });
          } else if (item.type.split(" ")[0] === "PUT") {
            await axios
              .put(
                `${baseURL}customerExtraInformation?userId=${auth?.id}`,
                JSON.stringify({
                  id: item.type.split(" ")[1],
                  idNumber: item.idNumber,
                  issueDate: new Date(item.issueDate),
                  exprationDate: new Date(item.exprationDate),
                  filePath: item.filePath,
                  idTypeId: item.idTypeId,
                  customerId: item.customerId,
                  imageSize: item.imageSize,
                  uploadedAt: new Date(item.uploadedAt),
                  uploadedBy: item.uploadedBy
                }),
                {
                  headers: {
                    'X-Tenant-ID': tenantId,
                    "Content-Type": "application/json"
                  },
                  withCredentials: true,
                }
              )
              .then(() => {
                if (extraRow?.length === (index + 1) && !shouldBlockNextPage) {
                  getDataFromCustomer(customerId, localAddress);
                  goToNextPage(4);
                }
                handleTenantError(null);
              })
              .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
              });
          } else {
            if (extraRow?.length === (index + 1) && !shouldBlockNextPage) {
              setPleaseWaitPopup(false);
            }
          }
        });
      } else {
        getDataFromCustomer(customerId, localAddress);
        goToNextPage(4);
      }
    };
  }

  useEffect(() => {
    let timeOutId: NodeJS.Timeout;
    setHasNextPage(true);
    setNextPageLoading(false);
    setPage(-1);
    if (searchValue !== "") {
      timeOutId = setTimeout(() => {
        setIsSearching(false);
        setOptions([]);
      }, 1000);
    } else {
      setOptions([]);
      setIsSearching(false);
    }

    return () => clearTimeout(timeOutId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const loadNextPage = () => {
    if (searchValue === "") {
      loadWithOutSearchOptions(pageNo + 1);
    } else {
      loadWithSearchOptions(pageNo + 1);
    }
  };

  const loadWithOutSearchOptions = (page: number) => {
    try {
      const pagination = {
        page: page,
        size: 15,
      };
      setNextPageLoading(true);
      fetch(`${baseURL}Customer/GetCustomersPaging/${pagination.page},${pagination.size}`, {
        method: "GET",
        headers: {
          'X-Tenant-ID': tenantId,
          "Content-Type": "application/json"
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const dataOptions = data.customers.map((item: any) => {
            return {
              value: item.id,
              label: item.firstName + " " + item.lastName,
            };
          });

          const itemsData = options.concat(dataOptions);
          setOptions(itemsData);
          setNextPageLoading(false);
          setHasNextPage(itemsData.length < data.count);
          setPage(page);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } catch (error) {
      handleTenantError(error);
    }
  };

  const loadWithSearchOptions = (page: number) => {
    try {
      const pagination = {
        page: page,
        size: 15,
      };
      setNextPageLoading(true);
      fetch(`${baseURL}Customer/GetCustomersSearchWithCustomerNamePaging?customerName=${searchValue}&page=${pagination.page}&size=${pagination.size}`, {
        method: "GET",
        headers: {
          'X-Tenant-ID': tenantId,
          "Content-Type": "application/json"
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const dataOptions = data.customers.map((item: any) => {
            return {
              value: item.id,
              label: item.firstName + " " + item.lastName,
            };
          });

          const itemsData = options.concat(dataOptions);
          setOptions(itemsData);
          setNextPageLoading(false);
          setHasNextPage(itemsData.length < data.count);
          setPage(page);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } catch (error) {
      handleTenantError(error);
    }
  };

  return (
    <div className="w-full mt-4">
      {
        addNewCustomer ? (
          <AddNewCustomer
            handleCustomer={setCustomerId}
            closeNewCustomer={() => {
              setAddNewCustomer(false);
              setHideToolbar(false);
            }}
            customerId={0}
            isFromDriver={false}
            pickupDate={pickupDate}
            returnDate={returnDate}
            returnTime={returnTime}
          />
        ) : (
          <div className="w-full">
            <div className="w-full relative flex gap-2.5 -mt-7 ml-1 items-center">
              <div className="w-[70%]">
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Please select a customer</label>

                <CustomerSelectWrapper
                  hasNextPage={hasNextPage}
                  isNextPageLoading={isNextPageLoading}
                  setSearchValue={setSearchValue}
                  options={options}
                  selectedOption={selectedOption}
                  setPage={setPage}
                  loadNextPage={loadNextPage}
                  isSearching={isSearching}
                  setIsSearching={setIsSearching}
                  onChange={(selectedOption: any) => {
                    setCustomerId(selectedOption?.value)
                    setSelectedOption(selectedOption);
                  }}
                />
              </div>

              <span className={`text-[14px] font-semibold text-[#167AC3] mt-[1.25rem] cursor-pointer`}
                onClick={() => {
                  if (!isCompletedOrCancelled) {
                    setAddNewCustomer(true);
                    setHideToolbar(false);
                  }
                }}
              >
                or create a new one
              </span>
            </div>

            <div className="w-full mt-4">
              <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Customer Information
              </span>

              <Divider className={`w-full ${themeStyles.divider.bg}`} />

              <div className="w-full mt-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  {
                    customerId > 0 && (
                      <div className="w-full px-2">
                        <div className="grid grid-cols-2 gap-6">
                          {/* Row 1 */}
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              First Name
                            </label>
                            <input
                              type="text"
                              tabIndex={1}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={firstName}
                              onChange={(e) => setFirstName(e.target.value)}
                              required
                            />
                          </div>
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Last Name
                            </label>
                            <input
                              type="text"
                              tabIndex={2}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={lastName}
                              onChange={(e) => setLastName(e.target.value)}
                              required
                            />
                          </div>

                          {/* Row 2 */}
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Email Address
                            </label>
                            <EmailValidatedComponent
                              tabIndex={3}
                              text={emailAddress}
                              setText={setEmailAddress}
                              required={true}
                            />
                          </div>
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Phone Number
                            </label>
                            <PhoneNumberInput
                              tabIndex={4}
                              name={"phoneNumber"}
                              value={phoneNumber}
                              setValue={setPhoneNumber}
                              fontSize={"14px"}
                              paddingBlock={"5px"}
                              required={true}
                            />
                          </div>

                          {/* Row 3 */}
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Street
                            </label>
                            <input
                              type="text"
                              tabIndex={5}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={Street}
                              onChange={(e) => setStreet(e.target.value)}
                              required
                            />
                          </div>
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Street 2
                            </label>
                            <input
                              type="text"
                              tabIndex={6}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={street2}
                              onChange={(e) => setStreet2(e.target.value)}
                            />
                          </div>

                          {/* Row 4 */}
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              City
                            </label>
                            <input
                              type="text"
                              tabIndex={7}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              required
                            />
                          </div>
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              State
                            </label>
                            <input
                              type="text"
                              tabIndex={8}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={state}
                              onChange={(e) => setState(e.target.value)}
                              required
                            />
                          </div>

                          {/* Row 5 */}
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Zip
                            </label>
                            <input
                              type="text"
                              tabIndex={9}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={zip}
                              onChange={(e) => setZip(e.target.value)}
                              required
                            />
                          </div>
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Country
                            </label>
                            <input
                              type="text"
                              tabIndex={10}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={country}
                              onChange={(e) => setCountry(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* Birthday Selects */}
                        <div className="w-full mt-[16px] flex items-center gap-1.5">
                          <div className="w-[30%]">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                              Birthday
                            </label>
                            <Select
                              tabIndex={11}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  color: themeStyles.form.inputTextColor,
                                  borderRadius: '6px',
                                  padding: '1px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                  backgroundColor: themeStyles.main.mainBg,
                                  color: themeStyles.form.inputTextColor,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#167AC3"
                                    : state.isFocused
                                      ? themeStyles.topBar.menuItemsHoverColor
                                      : "transparent",
                                  color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                  fontWeight: 600
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={false}
                              isRtl={false}
                              isSearchable={false}
                              name="birthday"
                              value={monthNameOptions.find(
                                (item) => item.value === month
                              )}
                              onChange={(month: any) =>
                                setMonth(month ? month.value : "")
                              }
                              options={monthNameOptions}
                              required
                            />
                          </div>
                          <div className="mt-6">
                            <Select
                              tabIndex={12}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  color: themeStyles.form.inputTextColor,
                                  borderRadius: '6px',
                                  padding: '1px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                  backgroundColor: themeStyles.main.mainBg,
                                  color: themeStyles.form.inputTextColor,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#167AC3"
                                    : state.isFocused
                                      ? themeStyles.topBar.menuItemsHoverColor
                                      : "transparent",
                                  color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                  fontWeight: 600
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              isSearchable={true}
                              name="birthday"
                              value={daysOptions.find(
                                (item: any) => item.value === parseInt(day)
                              )}
                              onChange={(day: any) =>
                                setDay(day ? day.value : "")
                              }
                              options={daysOptions}
                              required
                            />
                          </div>
                          <div className="mt-6">
                            <Select
                              tabIndex={13}
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: "transparent",
                                  color: themeStyles.form.inputTextColor,
                                  borderRadius: '6px',
                                  padding: '1px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "14px",
                                  backgroundColor: themeStyles.main.mainBg,
                                  color: themeStyles.form.inputTextColor,
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? "#167AC3"
                                    : state.isFocused
                                      ? themeStyles.topBar.menuItemsHoverColor
                                      : "transparent",
                                  color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                                  fontWeight: 600
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.form.inputTextColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={false}
                              isLoading={false}
                              isClearable={true}
                              isRtl={false}
                              isSearchable={true}
                              name="birthday"
                              value={yearOptions.find(
                                (item: any) => item.value === parseInt(year)
                              )}
                              onChange={(year: any) =>
                                setYear(year ? year.value : "")
                              }
                              options={yearOptions}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    )
                  }

                  {
                    customerId > 0 && (
                      <div className="w-full mt-4">
                        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                          Extra Information
                        </span>

                        <Divider className={`w-full ${themeStyles.divider.bg}`} />

                        <div className="w-full mt-2">
                          <table className="min-w-full">
                            <tbody className="text-left">
                              <tr className={`border-b ${themeStyles.main.borderColor}`}>
                                <th className={`w-[15%] text-[12px] font-semibold mb-2 pr-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Type</th>
                                <th className={`w-[25%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>ID Number</th>
                                <th className={`w-[20%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Issued On</th>
                                <th className={`w-[20%] text-[12px] font-semibold mb-2 px-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Exp. Date</th>
                                <th className={`w-[25%] text-[12px] font-semibold mb-2 pl-[0.25rem] py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>File</th>
                              </tr>

                              {
                                extraRow?.map((row: ExtraInformation) => {
                                  return (
                                    <AddIdentification
                                      key={row?.id}
                                      itemIndex={row?.id}
                                      birthDay={new Date(`${year}-${month}-${day}`).toDateString()}
                                      handleDeleteExtraRow={(index) => handleDeleteExtraRow(index)}
                                      row={row}
                                      changeOnExtraValue={(row) => changeOnExtraValue(row)}
                                    />
                                  );
                                })
                              }
                            </tbody>
                          </table>

                          <div
                            className="group h-10 border-dashed !border-t-0 border border-[#D5D4D8] pt-1 flex justify-center items-center cursor-pointer"
                            onClick={() => {
                              if (!isCompletedOrCancelled) handleAddExtraRow();
                            }}
                          >
                            <p className="text-xs text-center text-[#167AC3] cursor-pointer font-medium group-hover:font-bold group-hover:scale-125">
                              <AddOutlined
                                sx={{
                                  fontSize: "16px",
                                  textAlign: "center",
                                }}
                              />
                              Add another Identification
                            </p>
                          </div>

                          <div className="w-full mt-2">
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Local Address</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={localAddress}
                              onChange={(e) => setLocalAddress(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  }

                  {
                    reservationId > 0 && (
                      <div className="w-full mt-4">
                        <div className={`text-[14px] font-semibold flex items-center gap-1.5 mb-2 cursor-pointer ${themeStyles.main.textHeadingColor}`} onClick={() => setIsHistory(!isHistory)}>
                          Reservations History
                          {
                            isHistory ? <span className={`material-symbols-outlined ${themeStyles.main.textHeadingColor} text-[25px] font-extralight`}>
                              keyboard_arrow_up
                            </span> : <span className={`material-symbols-outlined ${themeStyles.main.textHeadingColor} text-[25px] font-extralight`}>
                              keyboard_arrow_down
                            </span>
                          }
                        </div>

                        <Divider className={`w-full ${themeStyles.divider.bg}`} />

                        <div className="w-full mt-2">
                          {
                            isHistory && reservationHistoryLoaded && (
                              <table className="border-collapse text-[10px] w-full">
                                <thead>
                                  <tr className={`text-left border-b-2 ${themeStyles.main.borderColor}`}>
                                    <th className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>#</th>
                                    <th className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Pickup Date</th>
                                    <th className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Return Date</th>
                                    <th className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Vehicle Class</th>
                                    <th className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Status</th>
                                    <th className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Notes</th>
                                    <th className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Selected Discounts</th>
                                    <th className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Outstanding Balance</th>
                                    <th className={`p-[5px] ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Total Price</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {
                                    historyValue.map((item: any, index: number) => (
                                      <tr key={index} className={`border-b ${themeStyles.main.borderColor}`}>
                                        <td
                                          className={`p-[5px] border-r ${themeStyles.main.borderColor} text-blue-600 underline cursor-pointer`}
                                          onClick={() => {
                                            navigate(`/carrental/reservations/editreservation?id=${item?.id}`);
                                          }}
                                        >
                                          <p>{item?.bookingNumber}</p>
                                        </td>
                                        <td className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindTextColor}`}>
                                          <p>{moment(new Date(item?.pickupDate)).format(dateFormat)}</p>
                                        </td>
                                        <td className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindTextColor}`}>
                                          <p>{moment(new Date(item?.returenDate)).format(dateFormat)}</p>
                                        </td>
                                        <td className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindTextColor}`}>
                                          <p>{item?.vehicleClassName}</p>
                                        </td>
                                        <td className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindTextColor}`}>{item.status}</td>
                                        <td className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindTextColor}`}>
                                          <ul className="pl-3 list-disc m-0">
                                            {
                                              item?.notes?.map((note: string, i: number) => (
                                                <li key={i}>{note}</li>
                                              ))
                                            }
                                          </ul>
                                        </td>
                                        <td className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindTextColor}`}>
                                          {
                                            item?.selectedDiscounts?.map((discount: string, i: number) => (
                                              <span key={i}>
                                                {discount}
                                                {i !== item?.selectedDiscounts?.length - 1 && ", "}
                                              </span>
                                            ))
                                          }
                                        </td>
                                        <td className={`p-[5px] border-r ${themeStyles.main.borderColor} ${themeStyles.table.tailwindTextColor}`}>
                                          {parseFloat(item?.outstandingBalance)?.toFixed(2)}
                                        </td>
                                        <td className={`p-[5px] ${themeStyles.table.tailwindTextColor}`}>{item?.totalPrice}</td>
                                      </tr>
                                    ))
                                  }
                                </tbody>
                              </table>
                            )
                          }
                        </div>
                      </div>
                    )
                  }

                  {
                    isHistory && !reservationHistoryLoaded && (
                      <div className="w-full flex items-center justify-center mt-2">
                        <CircularProgress size="20px" />
                      </div>
                    )
                  }

                  <div className="flex gap-4 mt-6">
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg
                      }}
                      type="submit"
                    >
                      Next
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )
      }
    </div>
  )
}